export default "__VITE_ASSET__4802e9e9__"